import React from 'react';
import * as Styles from './OrderProcessing.styles';
import { IconLoading } from 'gatorcomponents';

const OrderProcessing = ({
  testId = 'order-processing',
  text = '',
}) => (
  <Styles.Wrapper data-testid={testId}>
    <IconLoading size="lg" />
    <Styles.Description>
      {text}
    </Styles.Description>
  </Styles.Wrapper>
);

export default OrderProcessing;
